import React from 'react';
import { Button, Checkbox, Dialog, Group } from '@economic/taco';
import { Trans } from '@lingui/macro';
import { useField } from 'react-final-form';
import ExternalLink from '~/app/shared/components/ExternalLink';
import imgCreditCard from '~/app/pages/market/onboarding/CustomerPayments/assets/document-with-credit-card-administrators-1.png';
import { Field } from '~/app/shared/components/Form';

interface Props {
    nextStep: () => void;
}

const SetUp = ({ nextStep }: Props) => {
    const {
        input: { value: consentValue },
    } = useField('consent');

    const onNextClick = () => {
        nextStep();
    };

    return (
        <>
            <Dialog.Title>
                <Trans>Set up Payment Link</Trans>
            </Dialog.Title>

            <div className="flex mt-4 justify-center">
                <img src={imgCreditCard} alt="" />
            </div>

            <div className="flex mt-4">
                <span>
                    <Trans>
                        Payment Link is offered in collaboration with the payment platform pensopay. pensopay is subject to the
                        Danish Money Laundering Act and you will therefore be asked some questions about your business so that
                        pensopay can approve you.
                    </Trans>
                </span>
            </div>
            <div className="flex flex-col mt-4">
                <strong>
                    <Trans>Data Sharing</Trans>
                </strong>
                <span>
                    <Trans>
                        When you use Payment Link, you are subject to our general subscription terms and conditions. Your company
                        and contact details will also be shared with pensopay.
                    </Trans>
                </span>
            </div>
            <div className="flex align-center mt-4 text-grey-700 whitespace-nowrap">
                <label className="mr-1">
                    <Field.Checkbox name="consent" fieldClassName="flex">
                        {({ input: { name, value, onChange } }) => (
                            <>
                                <Checkbox className="!mt-0 mr-2" name={name} checked={value} onChange={onChange} />
                                <span>
                                    <Trans>I accept pensopay’s</Trans>
                                </span>
                            </>
                        )}
                    </Field.Checkbox>
                </label>

                <span>
                    <ExternalLink href="#terms-and-conditions">
                        <Trans>terms and conditions</Trans>
                    </ExternalLink>{' '}
                    <Trans>and</Trans>{' '}
                    <ExternalLink href="#payment terms">
                        <Trans>payment terms</Trans>
                    </ExternalLink>
                </span>
            </div>

            <Group className="flex mt-4 justify-end">
                <Button appearance="primary" disabled={!consentValue} onClick={onNextClick}>
                    <Trans>Next</Trans>
                </Button>
            </Group>
        </>
    );
};

export default SetUp;
